var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Nav',{attrs:{"isFixed":_vm.bannerFixed}}),_c('Notice'),_c('Bottom'),_c('Float'),_c('el-backtop',{attrs:{"target":".home"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }